<template>
  <div class="analyse-table store-table-container">
    <div class="flex-btw">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane v-for="(item, i) in tabPanes" :key="i" :label="item.name" :name="item.id"></el-tab-pane>
      </el-tabs>

      <!-- 导出按钮 -->
      <el-tooltip class="item" effect="dark" content="导出" placement="left">
        <span class="border-icon" @click="handleExport">
          <i class="iconfont icon-a-lujing207"></i></span>
      </el-tooltip>
    </div>
    <template v-if="activeName === '1'">
      <el-table :data="summaryTableData" v-loading="loading" tooltip-effect="light" stripe
        :height="'calc(100vh - 304px)'" style="width: 100%" class="summary-table" :border="false"
        :summary-method="getClassifySummaries" show-summary>
        <el-table-column prop="pom_name" label="门店名称">
          <template #default="scope">
            <span class="text-black">
              {{ scope.row.pom_name }}
            </span></template>
        </el-table-column>
        <el-table-column label="金额(元)">
          <el-table-column prop="or_allmoney" label="销售金额">
            <template #default="scope">
              <span class="text-grey">
                {{ scope.row.or_allmoney }}
              </span></template></el-table-column>
          <el-table-column prop="or_refund_money" label="退款金额">
            <template #default="scope">
              <span class="text-red">
                {{ scope.row.or_refund_money }}
              </span></template></el-table-column>
          <el-table-column prop="real_money" label="实收金额">
            <template #default="scope">
              <span class="text-theme">
                {{ scope.row.real_money }}
              </span></template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="数量">
          <el-table-column prop="order_no" label="销售">
            <template #default="scope">
              <span class="text-grey">
                {{ scope.row.order_no }}
              </span></template>
          </el-table-column>
          <el-table-column prop="refundNumber" label="退款">
            <template #default="scope">
              <span class="text-red">
                {{ scope.row.refundNumber }}
              </span></template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="统计周期">
          <el-table-column prop="start" label="开始时间">
            <template #default="scope">
              <span class="text-grey">
                {{ scope.row.start }}
              </span></template></el-table-column>
          <el-table-column prop="end" label="截止时间">
            <template #default="scope">
              <span class="text-grey">
                {{ scope.row.end }}
              </span></template></el-table-column>
        </el-table-column>
      </el-table>
    </template>
    <template v-if="activeName === '2'">
      <el-table v-loading="loading" :data="tableData" tooltip-effect="light" stripe :height="'calc(100vh - 416px)'"
        style="width: 100%">
        <el-table-column property="order_sn" label="订单编号">
          <template #default="scope">
            <span class="text-grey">
              {{ scope.row.order_sn }}
            </span></template>
        </el-table-column>
        <el-table-column property="name" label="售卖门店">
          <template #default="scope">
            <span class="text-grey">
              {{ scope.row.name }}
            </span></template>
        </el-table-column>
        <el-table-column property="order_type" label="发生类型">
          <template #default="scope">
            <span :class="scope.row.order_type == 1 ? 'text-theme' : 'text-red'">
              {{ ["", "收入", "支出"][scope.row.order_type] }}
            </span>
          </template>
        </el-table-column>
        <el-table-column property="money" label="金额">
          <template #default="scope">
            <span :class="scope.row.order_type == 1 ? 'text-orange' : 'text-red'">
              {{ scope.row.money }}
            </span>
          </template>
        </el-table-column>
        <el-table-column property="payway_name" label="支付方式">
          <template #default="scope">
            <span class="text-grey">
              {{ scope.row.payway_name }}
            </span></template>
        </el-table-column>
        <el-table-column property="order_time" label="支付时间">
          <template #default="scope">
            <span class="text-grey">
              {{ scope.row.order_time }}
            </span></template>
        </el-table-column>
      </el-table>
      <div class="statistics-container" v-if="statisticsData">
        <div class="statistics-item">
          <span class="label">销售金额：</span>
          <span class="number text-theme">￥{{ roundNumber(statisticsData.pay_money) }}</span>
        </div>
        <div class="statistics-item">
          <span class="label">退款金额：</span>
          <span class="number text-red">￥{{ roundNumber(statisticsData.refund_money) }}</span>
        </div>
        <div class="statistics-item">
          <span class="label">实收金额：</span>
          <span class="number text-orange">
            ￥{{
              roundNumber(
                roundNumber(statisticsData.pay_money) -
                  roundNumber(statisticsData.refund_money)
              )
            }}
          </span>
        </div>
      </div>
      <div class="pagination-container">
        <el-pagination v-model:currentPage="listQuery.page" v-model:page-size="listQuery.limit"
          :page-sizes="[20, 50, 100, 200, 500]" background layout="total, sizes, prev, pager, next, jumper"
          :total="listQuery.total" @size-change="handleSizeChange" @current-change="handleCurrentPageChange">
        </el-pagination>
      </div>
    </template>
  </div>
</template>

<script>
  import { ref, watch, nextTick } from "vue";
  import { AnalyseApi } from "@/plugins/api.js";
  import { ElMessage } from "element-plus";
  import { exportExcel, print } from "@/utils/common.js";

  export default {
    props: {
      queryData: {
        type: Object,
        default: async () => { },
      },
      echartClick: {
        type: Boolean,
        default: false,
      },
    },
    emits: ["showSelect", "clearFilter",],
    setup(props, { emit }) {
      const tabPanes = ref([{ id: '1', name: '门店订单汇总' }, { id: '2', name: '门店订单明细' }])
      const sendParmas = ref({});
      watch(
        () => props.queryData,
        (data) => {
          const lastData = JSON.parse(JSON.stringify(data));
          const parmas = {
            stime: lastData.stime,
            etime: lastData.etime,
            payway: lastData.payway,
            pom_id: lastData.storeId,
            s_id: lastData.scenicId,
          };
          sendParmas.value = parmas;
          nextTick(() => {
            props.echartClick ? (activeName.value = "2") : false;
            emit("showSelect", activeName.value == "2" ? true : false);
            fetchData(activeName.value);
          });
        },
        {
          deep: true,
          immediate: true,
        }
      );

      const listQuery = ref({
        page: 1,
        limit: 20,
        total: 0,
      });

      const tableData = ref([]);
      const summaryTableData = ref([]);
      const statisticsData = ref([]);

      const loading = ref(false);
      function fetchData(type) {
        loading.value = true;
        type === "1" &&
          AnalyseApi.getStoreSummaryTotal({
            etime: sendParmas.value.etime,
            stime: sendParmas.value.stime,
            s_id: sendParmas.value.s_id,
            pay_way: sendParmas.value.payway.length
              ? sendParmas.value.payway.join(",")
              : "",
            pom_id: sendParmas.value.pom_id.length
              ? sendParmas.value.pom_id.join(",")
              : "",
          }).then((res) => {
            loading.value = false;
            if (res.Code === 200) {
              summaryTableData.value = res.Data || [];
              summaryTableData.value.length &&
                summaryTableData.value.forEach((el) => {
                  el.refundNumber =
                    el.orr_refund && el.orr_refund.refund_no
                      ? el.orr_refund.refund_no
                      : 0;
                });
            } else {
              let msg = res.Message ? res.Message : "获取数据失败！";
              ElMessage.error(msg);
            }
          });
        type === "2" &&
          AnalyseApi.getStoreSummary({
            ...sendParmas.value,
            page: listQuery.value.page,
            limit: listQuery.value.limit,
            search_type: 2,
          }).then((res) => {
            loading.value = false;
            if (res.Code === 200) {
              tableData.value = res.Data.list;
              statisticsData.value = res.Data.total;
              listQuery.value.total = res.Data.total.num;
            } else {
              let msg = res.Message ? res.Message : "获取数据失败！";
              ElMessage.error(msg);
            }
          });
      }
      function roundNumber(num) {
        return Math.round(+num * 100) / 100;
      }
      function handleSizeChange(val) {
        listQuery.value.limit = val;
        fetchData(activeName.value);
      }
      function handleCurrentPageChange(p) {
        listQuery.value.page = p;
        fetchData(activeName.value);
      }
      const activeName = ref("1");
      function handleClick(tab) {
        // emit("clearFilter");
        emit("showSelect", tab.props.name == "2" ? true : false);
        fetchData(tab.props.name);
      }
      function getTime(data, type) {
        // type 1最小 2最大
        let newArr = data.map((ele) => {
          return new Date(ele).getTime();
        });
        let minIndex = 0;
        let minDate = newArr[0];
        let maxIndex = 0;
        let maxDate = newArr[0];
        newArr.forEach((ele, index) => {
          if (ele < minDate) {
            minDate = ele;
            minIndex = index;
          }
          if (ele > maxDate) {
            maxDate = ele;
            maxIndex = index;
          }
        });

        return data[type === 1 ? minIndex : maxIndex];
      }
      const getClassifySummaries = (param) => {
        const { columns, data } = param;
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = "合计";
            return;
          } else if (index === 6) {
            const timeData = data.map((item) => item[column.property]);
            sums[index] = getTime(timeData, 1);
          } else if (index === 7) {
            const timeData = data.map((item) => item[column.property]);
            sums[index] = getTime(timeData, 2);
          } else {
            const values = data.map((item) => Number(item[column.property]));
            if (!values.every((value) => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return roundNumber(prev + curr);
                } else {
                  return roundNumber(prev);
                }
              }, 0);
              sums[index] += "";
            } else {
              sums[index] = "N/A";
            }
          }
        });

        return sums;
      };
      const summaryPropertiesConfig = ref([
        { field: "pom_name", displayName: "门店名称" },
        { field: "or_allmoney", displayName: "金额(元)-销售金额" },
        { field: "or_refund_money", displayName: "金额(元)-退款金额" },
        { field: "real_money", displayName: "金额(元)-实收金额" },
        { field: "order_no", displayName: "数量-销售数量" },
        { field: "refundNumber", displayName: "数量-退款数量" },
        { field: "start", displayName: "统计周期-开始时间" },
        { field: "end", displayName: "统计周期-截止时间" },
      ]);
      const propertiesConfig = ref([
        { field: "order_sn", displayName: "订单编号" },
        { field: "name", displayName: "售卖门店" },
        { field: "typeText", displayName: "发生类型" },
        { field: "money", displayName: "金额" },
        { field: "payway_name", displayName: "支付方式" },
        { field: "order_time", displayName: "支付时间" },
      ]);

      function processData(data) {
        data.length &&
          data.forEach((el) => {
            el.typeText = ["", "收入", "支出"][el.order_type];
          });
        return data;
      }
      function getLastData() {
        let title = "";
        let data = null;
        let config = null;
        if (activeName.value === "1") {
          title = "门店订单汇总";
          data = summaryTableData.value;
          config = summaryPropertiesConfig.value;
        } else {
          title = "门店订单明细";
          data = storeDetails.value;
          config = propertiesConfig.value;
        }
        return [title, data, config];
      }
      const storeDetails = ref([]);
      const getExportDatas = () => {
        AnalyseApi.getStoreSummary({
          ...sendParmas.value,
          page: 1,
          limit: 10000000,
          search_type: 2,
        }).then((res) => {
          if (res.Code === 200) {
            storeDetails.value = res.Data.list ? res.Data.list : [];
            try {
              exportExcel(
                getLastData()[0],
                processData(getLastData()[1]),
                getLastData()[2]
              );
              ElMessage.success({
                message: "导出成功！",
              });
            } catch (e) {
              ElMessage.error({
                message: "导出失败！",
              });
            }
          } else {
            ElMessage.error(res.Message);
          }
        });
      }
      function handlePrint() {
        print(getLastData()[0], processData(getLastData()[1]), getLastData()[2]);
      }
      function handleExport() {
        if (activeName.value == '1') {
          try {
            exportExcel(
              getLastData()[0],
              processData(getLastData()[1]),
              getLastData()[2]
            );
            ElMessage.success({
              message: "导出成功！",
            });
          } catch (e) {
            ElMessage.error({
              message: "导出失败！",
            });
          }
        } else {
          getExportDatas();
        }
      }
      return {
        tableData,
        loading,
        handleSizeChange,
        handleCurrentPageChange,
        listQuery,
        handleExport,
        handlePrint,
        statisticsData,
        roundNumber,
        activeName,
        handleClick,
        summaryTableData,
        getClassifySummaries,
        getTime,
        tabPanes,
        storeDetails,
        getExportDatas,
      };
    },
  };
</script>

<style lang="scss">
</style>